<template>
    <div class="ppv2-grid ppv2-grid-cols-2 ppv2-gap-4 ppv2-w-full ppv2-pt-2">
        <BaseButton
            variant="outline"
            @click="$emit('cancel')"
            :customClass="`!ppv2-h-[48px] !ppv2-rounded-xl ppv2-bg-white dark:ppv2-bg-dark-popup ${cancelClass}`"
        >
            {{ cancelLabel || $t('common.cancel') }}
        </BaseButton>

        <BaseButton
            :variant="confirmVariant"
            @click="$emit('confirm')"
            :disabled="disabled"
            :customClass="`!ppv2-h-[48px] !ppv2-rounded-xl ${confirmClass}`"
        >
            <div class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-2">
                <!-- Special icons based on type -->
                <svg
                    v-if="type === 'download'"
                    width="18"
                    height="18"
                    viewBox="0 0 21 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 11.518C0 9.37251 1.12811 7.49047 2.82353 6.43275C3.28465 2.80486 6.38268 0 10.1358 0C13.889 0 16.987 2.80486 17.4481 6.43275C19.1436 7.49047 20.2717 9.37251 20.2717 11.518C20.2717 14.6708 17.8356 17.2546 14.743 17.4899L5.52864 17.5074C2.43608 17.2546 0 14.6708 0 11.518ZM14.6033 15.6523C16.7533 15.4888 18.4288 13.689 18.4288 11.518C18.4288 10.0686 17.681 8.75017 16.4727 7.99634L15.7303 7.53314L15.62 6.66512C15.2715 3.92352 12.9267 1.84288 10.1358 1.84288C7.34494 1.84288 5.00016 3.92352 4.6517 6.66512L4.54137 7.53314L3.79899 7.99634C2.59068 8.75017 1.84288 10.0686 1.84288 11.518C1.84288 13.689 3.51836 15.4888 5.66842 15.6523L5.82811 15.6645H14.4436L14.6033 15.6523ZM11.0573 9.2144H13.8216L10.1358 13.8216L6.45008 9.2144H9.2144V5.52864H11.0573V9.2144Z"
                        fill="currentColor"
                    />
                </svg>
                <Send v-if="type === 'send'" :size="16" />

                <span>{{ confirmLabel }}</span>
            </div>
        </BaseButton>
    </div>
</template>

<script>
import BaseButton from '../../../Shared/BaseButton.vue'
import { Send } from 'lucide-vue'

export default {
    name: 'ModalActions',
    components: {
        BaseButton,
        Send,
    },

    props: {
        confirmLabel: {
            type: String,
            required: true,
        },
        cancelLabel: {
            type: String,
            default: '',
        },
        confirmVariant: {
            type: String,
            default: 'primary',
        },
        type: {
            type: String,
            default: '', // 'download', 'send', etc.
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        confirmClass: {
            type: String,
            default: '',
        },
        cancelClass: {
            type: String,
            default: '',
        },
    },
}
</script>
